import { localized } from "@msuite/ui/localization";
import { createColumnHelper, createRowActions } from "@msuite/ui/table";
import { guardString } from "@msuite/utils/strings";
import type { IncomingInvoiceReminderListItem } from "@msuite/utils/types";
import { formatInvoiceAmount, formatInvoiceDate } from "@/components/incoming-invoices";
import { ReminderInvoiceCell } from "./reminder-invoice-cell";
import { ReminderLevelCell } from "./reminder-level-cell";
import { RowActions } from "./row-actions";

const columnHelper = createColumnHelper<IncomingInvoiceReminderListItem>();

export const columns = [
	columnHelper.accessor("reminderDate", {
		id: "reminderDate",
		header: localized("incoming_invoices.reminders.reminder_date"),
		cell: (cell) => formatInvoiceDate(cell.getValue()),
		size: 130,
	}),
	columnHelper.accessor("level", {
		id: "level",
		header: localized("incoming_invoices.reminders.level"),
		cell: (cell) => <ReminderLevelCell level={cell.getValue()} />,
		size: 140,
	}),
	columnHelper.accessor("issuerName", {
		id: "issuerName",
		header: localized("incoming_invoices.supplier"),
		cell: (cell) => guardString(cell.getValue()),
	}),
	columnHelper.accessor("referencedInvoiceNumber", {
		id: "referencedInvoiceNumber",
		header: localized("incoming_invoices.number"),
		cell: (cell) => guardString(cell.getValue()),
		size: 160,
	}),
	columnHelper.accessor("amountDue", {
		id: "amountDue",
		header: localized("incoming_invoices.reminders.amount_due"),
		cell: (cell) => formatInvoiceAmount(cell.getValue(), cell.row.original.currency),
		size: 130,
	}),
	columnHelper.accessor("fee", {
		id: "fee",
		header: localized("incoming_invoices.reminders.fee"),
		cell: (cell) => formatInvoiceAmount(cell.getValue() ?? 0, cell.row.original.currency),
		size: 110,
	}),
	columnHelper.accessor("dueDate", {
		id: "dueDate",
		header: localized("incoming_invoices.due_date"),
		cell: (cell) => formatInvoiceDate(cell.getValue()),
		size: 130,
	}),
	columnHelper.accessor((row) => row.invoice?.number ?? null, {
		id: "invoice",
		header: localized("incoming_invoices.invoice"),
		cell: (cell) => <ReminderInvoiceCell invoice={cell.row.original.invoice} />,
		size: 170,
	}),
	createRowActions(RowActions),
];
